<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="rich-text simple-richtext">
        <rich-text :content="parsedContent.content" />
    </div>
</template>

<script setup lang="ts">
const props: any = defineProps({ richtext: { type: Object, default: null } });
import type { VNode } from 'vue';
import { createTextVNode, h } from 'vue';
import { StoryblokComponent } from '@storyblok/vue';
import {
    BlockTypes,
    richTextResolver,
    type StoryblokRichTextNode,
    type StoryblokRichTextOptions,
} from '@storyblok/richtext';

import { fixContentItemLinks } from '~/utils/fixRichTextLinks';
const parsedContent = computed(() => {
    let parsed = props.richtext;
    fixContentItemLinks(parsed);
    return parsed;
});

const options: StoryblokRichTextOptions<VNode> = {
    renderFn: h,
    textFn: createTextVNode,
    resolvers: {
        [BlockTypes.COMPONENT]: (node: StoryblokRichTextNode<VNode>) => {
            return node?.attrs?.body.map((blok) => {
                return h(StoryblokComponent, {
                    blok: blok,
                });
            });
        },
    },
};

const richText = (content: any) => {
    return richTextResolver<VNode>(options).render(content.content);
};
</script>

<style scoped>
:deep(ol) {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
:deep(ul) {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
</style>
